import style from "../style/Map.module.css";


const getPos = (coord: number) => {
    let perc = (coord + 500) / 10;
    return `${perc}%`;
}

export const getBHTranslate = (system: {id: string}) => {
    let my = 0, mx = 0, moved = false;
    if(system.id === '9:1487') {
        my = 14;
        mx = 0;
        moved = true;
    }
    return {mx, my, moved};
}

const UserLocation = ({location}: {location: UserLocation}) => {
    if(!location) {
        return null;
    }
    let coords = location.coordinates.galaxy.attributes;
    let name = location.system ? location.system.value : `Deep space (${coords.x}, ${coords.y})`;
    return <div className={style.currentLocation} style={{bottom: getPos(coords.y), left: getPos(coords.x)}} title={name} ><div className={style.dotPurple} /></div>;
}

const TAN = Math.tan(22.5 * (Math.PI / 180));

const scanDirs = [
    [TAN,-1],
    [1, -TAN],
    [1, TAN],
    [TAN, 1],
    [-TAN, 1],
    [-1, TAN],
    [-1, -TAN],
    [-1, -TAN],
    [-TAN, -1],
];
const colors = {
    fill: 'rgba(23,23,157,0.15)',
    strokeHelp: 'rgba(37,37,133,0.65)',
    strokeFound: 'rgba(48,87,175,0.85)',
    // strokeScan: 'rgba(57,143,0,0.85)'
    strokeScan: 'rgba(178,27,27,0.85)'
}

export {UserLocation, getPos, TAN, scanDirs, colors};
